import { formatThousandsInt } from '../../../../../utils/format/formatThousands';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { Wrapper } from './styles';
import { BusinessStatisticItemProps } from './types';

export const BusinessStatisticItem = (props: BusinessStatisticItemProps) => {
    const { displayValue, diffValue, diffDisplay, title, ...other } = props;
    const isPositiveValue = diffValue >= 0;
    const formattedDiffValue = diffValue
        ? `${isPositiveValue ? '+' : ''}${formatThousandsInt(diffValue)}%`
        : diffDisplay;
    const numValue = Number(displayValue);

    return (
        <Wrapper {...other}>
            <Typography variant="body" ml={other.withNestedListMarker ? 2 : 0}>
                {title}
            </Typography>
            <Flex direction="row" spacing={1} alignItems="baseline">
                {diffValue ? (
                    <Typography
                        variant="caption"
                        color={isPositiveValue ? 'var(--color-success)' : 'var(--color-danger)'}
                    >
                        {formattedDiffValue}
                    </Typography>
                ) : null}
                <Typography variant="body">
                    {numValue ? formatThousandsInt(numValue) : displayValue}
                </Typography>
            </Flex>
        </Wrapper>
    );
};
